import { OliveBox } from '@/core/blocks';
import { Typography } from '@/core/ui';
import type { IStatistics } from '@/types';
import { useTranslation } from 'react-i18next';

export const GameData = ({ gameData }: { gameData: IStatistics['games'] }) => {
  const { Draws = 0, Defeats = 0, Victories = 0 } = gameData || {};
  const { t } = useTranslation('translation');
  return (
    <>
      <Typography className='text-3xl text-chalk tracking-[1.5px] leading-[28.5px] font-semibold'>
        {t('competition.stats.game.games')}
      </Typography>
      <div className='flex flex-row space-x-12'>
        <OliveBox text={t('competition.stats.game.games')} value={Draws + Defeats + Victories} />
        <div className='flex flex-col justify-between items-start'>
          <RowItem name={t('competition.stats.game.wins')} value={Victories} />
          <RowItem name={t('competition.stats.game.draw')} value={Draws} />
          <RowItem name={t('competition.stats.game.defeat')} value={Defeats} />
        </div>
      </div>
    </>
  );
};

const RowItem = ({ value, name }: { value: number; name: string }) => {
  return (
    <div className='flex flex-row items-center justify-center space-x-5'>
      <div className='flex items-center justify-center border border-chalk rounded-lg px-5'>
        <Typography className='text-[36px] text-chalk font-semibold'>{value}</Typography>
      </div>
      <Typography className='text-[26px] text-chalk tracking-[1.82px] uppercase leading-[26px] font-semibold'>
        {name}
      </Typography>
    </div>
  );
};
